
import locationMixin from '~/mixins/location';
import promiseErrors from '~/services/promiseErrors';
import random from '~/services/random';

export default {
    name: 'FlyTippingCounty',
    mixins: [locationMixin],
    async asyncData({ app, route }) {
        const [cities, stats] = await promiseErrors(
            [
                app.$axios.$get(app.$config.endpoints.locations.city, { params: { county: route.params.county, per_page: 200 } }),
                app.$axios.get(app.$config.endpoints.serviceStats),
            ],
            app,
        );

        return {
            cities: cities?.cities?.data || [],
            county: cities?.county || {},
            reportsCount: cities?.stats?.reports_count || 0,
            stats: stats?.data || {},
        };
    },
    data() {
        return {
            cities: [],
            county: {},
            image: ['skip', 'grab-bag', 'man-in-a-van'][random(0, 2)],
            radius: 25,
            stats: {},
        };
    },
    head() {
        let title = `${this.$t('services.location.waste_remove_in', { location: this.county.name })}`;
        if (this.$route.query.page > 1) {
            title += ` - ${this.$t('common.page_x', { num: this.$route.query.page })}`;
        }
        return {
            title: `${title} - ClearWaste`,
            meta: [
                {
                    hid: 'description',
                    name: 'description',
                    content: `${this.$t('metadata.services-location.text', { location: this.county.name })}`,
                },
                {
                    hid: 'og:description',
                    name: 'og:description',
                    content: `${this.$t('metadata.services-location.text', { location: this.county.name })}`,
                },
                {
                    hid: 'og:title',
                    name: 'og:title',
                    content: `${title} - ClearWaste`,
                },
            ],
        };
    },
};
